import PropTypes from 'prop-types';

const Trash = ({ className = '' }) => (
  <svg width="8" height="10" viewBox="0 0 12 16" className={className}>
    <path
      fill="black"
      fillRule="nonzero"
      d="M11.368 4.42H.632A.632.632 0 0 1 0 3.79v-.632c0-.349.283-.631.632-.631h1.894c0-.926.195-1.467.627-1.899C3.585.194 4.124 0 5.05 0h1.9c.926 0 1.465.194 1.897.627.433.433.627.973.627 1.899h1.894c.35 0 .632.282.632.631v.632a.632.632 0 0 1-.632.631zm-3.47-2.844a1.213 1.213 0 0 0-.95-.313H5.052a1.213 1.213 0 0 0-.948.313c-.236.257-.35.603-.313.95h4.42a1.215 1.215 0 0 0-.313-.95zm2.836 3.476a.316.316 0 0 1 .316.335l-.557 8.882a.95.95 0 0 1-.949.888H2.455a.95.95 0 0 1-.949-.888L.95 5.387a.316.316 0 0 1 .317-.335h9.468z"
      opacity=".5"
    />
  </svg>
);

Trash.propTypes = {
  className: PropTypes.string
};

export default Trash;
